import React, { useState, useEffect } from 'react';
import "./sessions.css";
import { AppContainer } from './../salute/AppContainer';

const ClientSessionsComponent = (props) => {
    const [therapies, setTherapies] = useState(null);
    const [activeTherapy, setActiveTherapy] = useState(null);
    const [isSession, setIsSession] = useState(false);

    useEffect(() => {
        const fetchClients = async () => {
            try {
                const response = await fetch("https://meetmind.ru/v1/client/get-therapy-list");
                if (!response.ok) {
                    throw new Error("Ошибка загрузки клиентов");
                }
                const data = await response.json();
                setTherapies(data.therapy_list);
            } catch (error) {
                console.error("Ошибка:", error);
            }
        };

        fetchClients();
    }, []);

    const handleSessionStart = async (nearScheduleId) => {
        const requestData = {
            schedule_id: nearScheduleId,
        };

        try {
            const response = await fetch("https://meetmind.ru/v1/start-video-meeting", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestData),
            });

            if (!response.ok) {
                throw new Error("Ошибка записи сессии в календарь");
            }

            const data = await response.json();
            if (data.jazz_info) {
                sessionStorage.setItem("meetmindJazzUserName", data.jazz_info.user_name);
                sessionStorage.setItem("meetmindJazzToken", data.jazz_info.token);
                sessionStorage.setItem("meetmindJazzRoomID", data.jazz_info.room_id);
                sessionStorage.setItem("meetmindJazzRoomPassword", data.jazz_info.room_password);
                setIsSession(true);
            }
        } catch (error) {
            console.error("Ошибка записи сессии в календарь:", error);
        }
    };

    return (
        <div>
            <div className="flex-row">
                <div className="sessions__list">
                    <div className="flex-row mb-20">
                        <h4>Список сессий</h4>
                    </div>
                    <div >
                        <div>
                            {therapies != null && therapies.map(therapy => (
                                <div className="flex-column sessions_list-elements" onClick={() => setActiveTherapy(therapy)}>
                                    <div>
                                        <p className="space-nowrap  mr-10">
                                            {therapy.specialist}
                                        </p>
                                    </div>
                                    <div className="flex-row">
                                        <p className="sessions__grey-text full-width">
                                            {therapy.type}
                                        </p>
                                    </div>
                                    {therapy.is_prescribe == true &&
                                        <div className="flex-row">
                                            <p className="sessions__grey-text full-width">
                                                Встреча: {therapy.near_date}
                                            </p>
                                        </div>
                                    }
                                    {therapy.is_prescribe == false &&
                                        <div className="flex-row">
                                            <p className="sessions__grey-text full-width">
                                                Дата встречи ещё не назначена
                                            </p>
                                        </div>
                                    }
                                </div>
                            ))}
                            {therapies == null && (
                                <span>У вас нет сессий</span>
                            )}
                        </div>
                    </div>
                </div>
                <div className="flex-column sessions__screen">
                    {isSession && <AppContainer />}
                    <div className="sessions__bottom">
                        {!isSession && activeTherapy != null && activeTherapy.is_prescribe === true && (
                            <button className="btn btn-red mr-10" onClick={() => handleSessionStart(activeTherapy.near_schedule_id)}>Начать сессию сейчас</button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ClientSessionsComponent;